import { NAVIGATE_TO } from "../../../../constants/FileConstants";
export const supportedSystemOperationsData = {
  heading: "Supported system operations",
  description:
    "The HL7 FHIR documentation supports a variety of resources. Below are the accessible resources that are supported by the Elevance Health FHIR API.",
  table_header: "Supported system operations",
  table_columns: ["Operation Name", "Description"],
  table_data: [
    {
      name: "code-terms",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "code-terms",
        },
        {
          type: "text",
          value: "Elevance Health code terms",
        },
      ],
      subgroup: {
        heading: "System operation",
        description:
          "Gets all the Elevance Health terms corresponding to mapped FHIR codes OR terms in those same namespaces and families that do not correspond to any FHIR code",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "wrong",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "True to return the wrong terms: those in the right namespace and family but not corresponding to any FHIR code.",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "term",
                },
                {
                  type: "text",
                  value: "1..*",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "compose-coding-system",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "compose-coding-system",
        },
        {
          type: "text",
          value: "Compose a coding system URI",
        },
      ],
      subgroup: {
        heading: "System Operation",
        description:
          "Composes a coding system URI from the corresponding Elevance Health term namespace and term family",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "term-namespace-code",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "The code of the Elevance Health term namespace.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "term-namespace-version",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The optional version of the Elevance Health term namespace.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "term-family",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "The Elevance Health term family",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "compose-demographic-identifier-system",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "compose-demographic-identifier-system",
        },
        {
          type: "text",
          value: "Composes a demographic identifier system URI",
        },
      ],
      subgroup: {
        heading: "System Operation",
        description:
          "Composes an identifier system URI from the Elevance Health identifier type and assigning authority",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-code",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "The code of the Elevance Health identifier type term.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-namescope-code",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The code of the namespace of the Elevance Health identifier type term.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-namescope-version",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The optional version of the namespace of the Elevance Health identifier type term.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-namespace-identifier",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The namespace identifier of the Elevance Health assigning authority.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-universal-identifier",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The unniversal identifier of the Elevance Health assigning authority.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-universal-identifier-type",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The unniversal identifier type (e.g. ISO) of the Elevance Health assigning authority.",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "compose-identifier-system",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "compose-identifier-system",
        },
        {
          type: "text",
          value: "Composes an identifier system URI",
        },
      ],
      subgroup: {
        heading: "System Operation",
        description:
          "Composes an identifier system URI from the Elevance Health record authority",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "record-authority-code",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "The code of the Elevance Health record authority.",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "list-sources",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "list-sources",
        },
        {
          type: "text",
          value: "List the available sources",
        },
      ],
      subgroup: {
        heading: "System Operation",
        description:
          "List all the sources that can be specified when POSTing / PUTing / DELETEing data to this FHIR endpoint",
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "source",
                },
                {
                  type: "text",
                  value: "1..*",
                },
                {
                  type: "text",
                  value: "Parameters",
                },
                {
                  type: "text",
                  value: "Available Source",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "process-message",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "external",
          value: "process-message",
          href: "http://hl7.org/fhir/messageheader-operation-process-message.html",
        },
        {
          type: "text",
          value:
            "Process a bundle of FHIR data, process according to event definition, and reeturn a response message",
        },
      ],
    },
    {
      name: "remove-wrong-code-terms",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "remove-wrong-code-terms",
        },
        {
          type: "text",
          value: "Remove wrong Elevance Health code terms",
        },
      ],
      subgroup: {
        heading: "System Operation",
        description:
          "Removes all terms in the same namespaces and families of those corresponding to FHIR codes but that do not correspond to any FHIR code",
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "term",
                },
                {
                  type: "text",
                  value: "1..*",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value: "Terms that have been removed",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "validate-coding-system",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "validate-coding-system",
        },
        {
          type: "text",
          value: "Validates a coding system URI",
        },
      ],
      subgroup: {
        heading: "System operation",
        description:
          "Checks if a coding system URI is valid according to the FHIR specifications and the server internal rules. For valid URIs returns the corresponding Elevance Health term namespace and term families",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "target-term-family",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The term family to use for determining the system URI if the code system contains more than one term family",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "valid",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "True if the specified coding system URI is a valid one, false if it is invalid or not writable",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "term-namespace-code",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The code of the Elevance Health term namespace corresponding to the specified system URI. Not present if the system URI is not valid.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "term-namespace-version",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "The version of the Elevance Health term namespace corresponding to the specified system URI. Not present if the system URI is not valid.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "term-family",
                },
                {
                  type: "text",
                  value: "0..*",
                },
                {
                  type: "text",
                  value: "string",
                },
                {
                  type: "text",
                  value:
                    "Elevance Health term families corresponding to the specified system URI. The parameter is repeated for each of the families. Not present if the system URI is not valid.",
                },
              ],
            },
          ],
        },
      },
    },
    {
      name: "validate-identifier-system",
      path: `${NAVIGATE_TO.SUPPORTED_SYSTEM_OPERATIONS}`,
      values: [
        {
          type: "link",
          value: "validate-identifier-system",
        },
        {
          type: "text",
          value: "Validates an identifier system URI",
        },
      ],
      subgroup: {
        heading: "System operation",
        description:
          "Checks if an identifier system URI is valid according to the FHIR specifications and the server internal rules. For valid URIs returns the corresponding Elevance Health identifier type, assigning authority (if any) and record authority",
        inParameters: {
          header: "In Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "uri",
                },
                {
                  type: "text",
                  value: "",
                },
              ],
            },
          ],
        },
        outParameters: {
          header: "Out Parameters",
          columns: ["Name", "Cardinality", "Type", "Documentation"],
          data: [
            {
              values: [
                {
                  type: "text",
                  value: "valid",
                },
                {
                  type: "text",
                  value: "1..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "True if the specified identifier system URI is a valid one, false otherwise",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-code",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The code of the Elevance Health identifier type term corresponding to the specified system URI. Not present if the system URI is not valid.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-namespace-code",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The code of the namespace of the Elevance Health identifier type term corresponding to the specified system URI. Not present if the system URI is not valid.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "identifier-type-namespace-version",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The version of the namespace of the Elevance Health identifier type term corresponding to the specified system URI. Not present if the system URI is not valid.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-namespace-identifier",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The namespace identifier of the Elevance Health assigning authority corresponding to the specified system URI. Not present if the system URI is not valid or it does not correspond to an assigning authority.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-universal-identifier",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The universal identifier of the Elevance Health assigning authority corresponding to the specified system URI. Not present if the system URI is not valid or it does not correspond to an assigning authority.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "assigning-authority-universal-identifier-type",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The universal identifier type (e.g. ISO) of the Elevance Health assigning authority corresponding to the specified system URI. Not present if the system URI is not valid or it does not correspond to an assigning authority.",
                },
              ],
            },
            {
              values: [
                {
                  type: "text",
                  value: "record-authority-code",
                },
                {
                  type: "text",
                  value: "0..1",
                },
                {
                  type: "text",
                  value: "boolean",
                },
                {
                  type: "text",
                  value:
                    "The code of the Elevance Health record authority corresponding to the specified system URI. Not present if the system URI is not valid or it does not correspond to a record authority.",
                },
              ],
            },
          ],
        },
      },
    },
    
    {
      "mainNavigation": false,
      "name": "emergency-department",
      "subgroup": {
          "heading": "emergency-department",
          "description": "Get all emergency department claims and service requests for the patient",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "options"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "options, as name-value pairs in the 'part' elements"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "info"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "Claim and service request information"
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "available-versions",
      "subgroup": {
          "heading": "available-versions",
          "description": "Get a list of all available ValueSet.Version in the system with a total count of ValueSet for each",
          "inParameters": {
              "header": "",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": []
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "item"
                          },
                          {
                              "type": "text",
                              "value": "1..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "Returns a 'versions' parameter containing a list of 'item' with sub-parameters 'version-name' and 'total-count' for each each unique version in the system"
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "add",
      "subgroup": {
          "heading": "add",
          "description": "",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "member"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": []
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "classify",
      "subgroup": {
          "heading": "classify",
          "description": "Classify a list of codes: returns all the value sets each of the codes belongs to",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "system"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "system of the codes to classify"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "family"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "family (domain) of the codes to classify, required if the system does not corresponds to a single family"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "code"
                          },
                          {
                              "type": "text",
                              "value": "1..*"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "codes to classify"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "version"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "consider only value sets with this version"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "name"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "consider only value sets with this name"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "item"
                          },
                          {
                              "type": "text",
                              "value": "1..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "one for each of the specifies codes that is contained in at least one value set, with a part 'code' specifying the code and 'name' and 'version' parts for each value set. The 'version' part is omitted when a value set version is specified in the input parameters The 'name' part is omitted when a value set name is specified in the input parameters."
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "classify-visits",
      "subgroup": {
          "heading": "classify-visits",
          "description": "Classifies visits by type and subtype",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "id"
                          },
                          {
                              "type": "text",
                              "value": "1..*"
                          },
                          {
                              "type": "text",
                              "value": "Reference"
                          },
                          {
                              "type": "text",
                              "value": "Identifiers"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "return"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Parameters"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "match",
      "subgroup": {
          "heading": "match",
          "description": "Get MPI match data against input patient parameter",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "resource"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Resource"
                          },
                          {
                              "type": "text",
                              "value": "Patient resource providing demographic data (may only be partially complete but must minimally contain family name, given name, and a birthdate value)"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "onlyCertainMatches"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "boolean"
                          },
                          {
                              "type": "text",
                              "value": "Only return certain matches (default: true)"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "return"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Bundle"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "visits",
      "subgroup": {
          "heading": "visits",
          "description": "Retrieves Encounter, Claim, and ServiceRequest resources for a patient categorized by visit type and sub-type",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "include-locations"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "boolean"
                          },
                          {
                              "type": "text",
                              "value": "return relevant Location resources"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "include-practitioners"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "boolean"
                          },
                          {
                              "type": "text",
                              "value": "return relevant Practitioner resources"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "include-conditions"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "boolean"
                          },
                          {
                              "type": "text",
                              "value": "return relevant Condition resources"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "include-groups"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "boolean"
                          },
                          {
                              "type": "text",
                              "value": "Return visit groupings"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "return"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Parameters"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "remove",
      "subgroup": {
          "heading": "remove",
          "description": "",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "entity"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": "Reference"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": []
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "office-visits",
      "subgroup": {
          "heading": "office-visits",
          "description": "Get all office visits claims and service requests for the patient",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "options"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "options, as name-value pairs in the 'part' elements"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "info"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "Claim and service request information"
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "getpage",
      "subgroup": {
          "heading": "getPage",
          "description": "",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "count"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "integer"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "integer"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "query"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "return"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Group"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "everything",
      "subgroup": {
          "heading": "everything",
          "description": "",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "_type"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": "code"
                          },
                          {
                              "type": "text",
                              "value": "resource types to return"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "return"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "Bundle"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "inpatient",
      "subgroup": {
          "heading": "inpatient",
          "description": "Get all inpatient claims and service requests for the patient",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "options"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "options, as name-value pairs in the 'part' elements"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "info"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "Claim and service request information"
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "text-search",
      "subgroup": {
          "heading": "text-search",
          "description": "Search full text of reports",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "patient-id"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "Patient ID whose Reports are to be searched"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "query"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "query string"
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "info"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "Reports which match the query string"
                          }
                      ]
                  }
              ]
          }
      }
  },
  {
      "mainNavigation": false,
      "name": "accumulators",
      "subgroup": {
          "heading": "accumulators",
          "description": "Get all claim accumulators for the member",
          "inParameters": {
              "header": "In Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "coverage-level"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "coverage level: 'Individual' or 'NonIndividual' or empty for both, defaults to both"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "start"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date, defaults to the beginning of the same year of the end date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "end"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date, defaults to the current date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "plan-type"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "last-quarter"
                          },
                          {
                              "type": "text",
                              "value": "0..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": ""
                          }
                      ]
                  }
              ]
          },
          "outParameters": {
              "header": "Out Parameters",
              "columns": [
                  "Name",
                  "Cardinality",
                  "Type",
                  "Documentation"
              ],
              "data": [
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "usage"
                          },
                          {
                              "type": "text",
                              "value": "0..*"
                          },
                          {
                              "type": "text",
                              "value": ""
                          },
                          {
                              "type": "text",
                              "value": "member benefits usage for each coverage"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "desc"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "coverage description, eg 'IND DED IF FAM MBR EQUALS 1'"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "networkParticipation"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "'Participating' or 'Non Participating'"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "code"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "accumulator type: 'Deductible', 'OutOfPocketMax' etc."
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "benefitValue"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "decimal"
                          },
                          {
                              "type": "text",
                              "value": "total benefit value"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "accumulated"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "decimal"
                          },
                          {
                              "type": "text",
                              "value": "benefit accumulated to the specified date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "remaining"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "decimal"
                          },
                          {
                              "type": "text",
                              "value": "remaining benefit"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "coverageLevel"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "string"
                          },
                          {
                              "type": "text",
                              "value": "coverage level: 'Individual', 'Family' etc."
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "startDt"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "start date"
                          }
                      ]
                  },
                  {
                      "values": [
                          {
                              "type": "text",
                              "value": "endDt"
                          },
                          {
                              "type": "text",
                              "value": "1..1"
                          },
                          {
                              "type": "text",
                              "value": "date"
                          },
                          {
                              "type": "text",
                              "value": "end date"
                          }
                      ]
                  }
              ]
          }
      }
  }

  ],
};
